import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchClient } from "@babackapp/private-api-client/generated/client";
import { SESSION_TOKEN_KEY } from "@babackapp/private-api-client/client/use-session-token";
import type { ReturnDraft } from "../types";

export function useCreateRetractationReturnRequest(orderId: string, shopSlug: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (draft: ReturnDraft) => {
      const { data, response } = await fetchClient.POST(
        "/public/return-request/retractation",
        {
          body: {
            orderId: draft.orderId,
            shopId: draft.shopId,
            lineItems: draft.lineItems.map((li) => ({
              lineItemId: li.lineItemId,
              quantity: li.quantity,
            })),
            shippingAddress: draft.address!,
            notifications: { consumerEnabled: true },
          },
          params: {
            header: {
              authorization: `Bearer ${localStorage.getItem(SESSION_TOKEN_KEY) ?? ""}`,
            },
          },
        },
      );

      if (!response.ok) throw new Error("Failed to create retractation return request");
      return data;
    },
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: [
          "get",
          "/public/return-request/search",
          { params: { query: { orderId, shopSlug } } },
        ],
        refetchType: "all",
      }),
  });
}
